import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, MaterialIcon } from '@dsny/dsny-component-library'
import ModalActions from 'reducers/Modal'
import {
  playlistWelcomeCover01,
  playlistWelcomeCover02,
  playlistWelcomeCover03,
  playlistWelcomeCover04,
  playlistWelcomeCover05,
  playlistWelcomeCover06,
  playlistWelcomeCover07,
  playlistWelcomeCover08,
  playlistWelcomeCover09,
  playlistWelcomeCover10,
  playlistWelcomeCover11,
  playlistWelcomeCover12,
  playlistWelcomeCover13,
  playlistWelcomeCover14
} from 'images'
import {
  AddIcon,
  CompactExampleTitle,
  CoverGrid,
  CoverImage,
  DesktopExampleTitle,
  ExampleCard,
  ExampleGrid,
  ExampleInfo,
  ExamplesContainer,
  ExamplesFade,
  ExampleTitle,
  SongCount,
  WelcomeActions,
  WelcomeContainer,
  WelcomeContent,
  WelcomeDescription,
  WelcomeTitle
} from './FirstPlaylistWelcome.styles'

const EXAMPLE_PLAYLISTS = [
  {
    covers: [
      playlistWelcomeCover01,
      playlistWelcomeCover02,
      playlistWelcomeCover03,
      playlistWelcomeCover04
    ],
    songCount: 5
  },
  {
    covers: [
      playlistWelcomeCover05,
      playlistWelcomeCover06,
      playlistWelcomeCover07
    ],
    songCount: 3
  },
  {
    covers: [
      playlistWelcomeCover08,
      playlistWelcomeCover09,
      playlistWelcomeCover10,
      playlistWelcomeCover11
    ],
    songCount: 21
  },
  {
    covers: [playlistWelcomeCover12, playlistWelcomeCover09],
    songCount: 2
  },
  {
    covers: [
      playlistWelcomeCover01,
      playlistWelcomeCover13,
      playlistWelcomeCover14
    ],
    songCount: 3
  }
]

const FirstPlaylistWelcome = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleCreatePlaylist = () => {
    dispatch(ModalActions.openPlaylistModal('playlist_first_run'))
  }

  return (
    <WelcomeContainer>
      <WelcomeContent>
        <WelcomeTitle>{t('playlist.first-playlist-title')}</WelcomeTitle>
        <WelcomeDescription>
          {t('playlist.first-playlist-description')}
        </WelcomeDescription>
        <WelcomeActions>
          <Button
            setting="player"
            type="button"
            variant="primary"
            onClick={handleCreatePlaylist}
          >
            <AddIcon aria-hidden="true">
              <MaterialIcon name="Add" />
            </AddIcon>
            {t('playlist.create-playlist')}
          </Button>
          <Button
            setting="player"
            type="button"
            variant="secondary"
            onClick={() => navigate('/releases')}
          >
            {t('playlist.browse-releases')}
          </Button>
        </WelcomeActions>
      </WelcomeContent>

      <ExamplesContainer aria-hidden="true">
        <ExampleGrid>
          {EXAMPLE_PLAYLISTS.map(({ covers, songCount }, index) => (
            <ExampleCard key={songCount + index}>
              <CoverGrid>
                {covers.map((cover, coverIndex) => (
                  <CoverImage
                    key={cover}
                    alt=""
                    src={cover}
                    $spanColumns={
                      covers.length === 2 ||
                      (covers.length === 3 && coverIndex === covers.length - 1)
                    }
                  />
                ))}
              </CoverGrid>
              <ExampleInfo>
                <SongCount>
                  {t('playlist.example-song-count', { count: songCount })}
                </SongCount>
                <ExampleTitle>
                  <CompactExampleTitle>
                    {t('playlist.example-playlist-title-compact')}
                  </CompactExampleTitle>
                  <DesktopExampleTitle>
                    {t('playlist.example-playlist-title', {
                      number: index + 1
                    })}
                  </DesktopExampleTitle>
                </ExampleTitle>
              </ExampleInfo>
            </ExampleCard>
          ))}
        </ExampleGrid>
        <ExamplesFade />
      </ExamplesContainer>
    </WelcomeContainer>
  )
}

export default FirstPlaylistWelcome
